// Cult Affiliates — referral attribution helpers
// Stores incoming ?ref=CODE in localStorage with a 30-day TTL, exposes share builders.

const KEY = "cultlyf_ref";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get("ref") || "").trim().toUpperCase();
    if (!code) return null;
    localStorage.setItem(
      KEY,
      JSON.stringify({ code, ts: Date.now() })
    );
    // Optional: ping click counter (fire-and-forget)
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/affiliate/track-click?code=${encodeURIComponent(code)}`,
      { method: "POST" }
    ).catch(() => {});
    return code;
  } catch {
    return null;
  }
}

export function getStoredRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code || !ts) return null;
    if (Date.now() - ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearStoredRef() {
  try { localStorage.removeItem(KEY); } catch {/* noop */}
}

// Build an absolute product URL with the referral code embedded.
export function buildShareUrl(slug, refCode) {
  const origin = window.location.origin;
  const path = `/product/${slug}`;
  const url = new URL(path, origin);
  if (refCode) url.searchParams.set("ref", refCode);
  return url.toString();
}

// Build the OG-rich share URL (backend endpoint) — this is what we paste into WhatsApp / FB / X / Email.
// Backend serves OG meta tags so crawlers can render a rich preview with product image.
export function buildOgShareUrl(slug, refCode) {
  const origin = window.location.origin;
  const url = new URL(`/api/share/product/${slug}`, origin);
  if (refCode) url.searchParams.set("ref", refCode);
  return url.toString();
}

// Platform-specific share links
export function shareLinks({ url, text, title }) {
  const t = encodeURIComponent(text || "");
  const u = encodeURIComponent(url);
  const subj = encodeURIComponent(title || "Check this out — Cult Lyf");
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${t}`,
    twitter: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
    email: `mailto:?subject=${subj}&body=${t}%0A%0A${u}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
  };
}
